import { render, staticRenderFns } from "./ShiftBin.vue?vue&type=template&id=891ab59c&scoped=true"
import script from "./ShiftBin.vue?vue&type=script&lang=ts"
export * from "./ShiftBin.vue?vue&type=script&lang=ts"
import style0 from "./ShiftBin.vue?vue&type=style&index=0&id=891ab59c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891ab59c",
  null
  
)

export default component.exports